import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=3ac94568&"
import script from "./avatar.vue?vue&type=script&setup=true&lang=js&"
export * from "./avatar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports